import { useState, useEffect } from "react";

/** @typedef {{ labels: Record<string,string>, meta: Record<string,{firstName:string,lastName:string}> }} FopLabelsCache */

/** @type {FopLabelsCache | null} */
let cache = null;
let pending = null;

function emptyBuckets() {
    return { labels: {}, meta: {} };
}

/**
 * Підписи ФОП для Mono з /api/users/fops (авторизований користувач).
 */
export function useFopLabels() {
    const init = cache || emptyBuckets();
    const [labelBySlug, setLabelBySlug] = useState(() => init.labels || {});
    const [fopMetaBySlug, setFopMetaBySlug] = useState(() => init.meta || {});
    const [slugs, setSlugs] = useState(() => Object.keys(init.labels || {}));
    const [loading, setLoading] = useState(!cache);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (cache) {
            setLabelBySlug(cache.labels || {});
            setFopMetaBySlug(cache.meta || {});
            setSlugs(Object.keys(cache.labels || {}));
            setLoading(false);
            return undefined;
        }
        const p =
            pending ||
            fetch("/api/users/fops", { credentials: "include" })
                .then((r) => {
                    if (!r.ok) throw new Error(String(r.status));
                    return r.json();
                })
                .then((data) => {
                    const labels = {};
                    const meta = {};
                    (data.items || []).forEach(
                        ({ slug, label, firstName, lastName }) => {
                            labels[slug] = label;
                            meta[slug] = {
                                firstName:
                                    typeof firstName === "string"
                                        ? firstName.trim()
                                        : "",
                                lastName:
                                    typeof lastName === "string"
                                        ? lastName.trim()
                                        : "",
                            };
                        }
                    );
                    cache = { labels, meta };
                    return cache;
                })
                .finally(() => {
                    pending = null;
                });
        pending = p;
        setLoading(true);
        setError(null);
        p.then((c) => {
            setLabelBySlug(c.labels);
            setFopMetaBySlug(c.meta);
            setSlugs(Object.keys(c.labels));
        })
            .catch((e) => {
                setError(e);
                const e0 = emptyBuckets();
                setLabelBySlug(e0.labels);
                setFopMetaBySlug(e0.meta);
                setSlugs([]);
            })
            .finally(() => setLoading(false));
        return undefined;
    }, []);

    const getLabel = (slug) => labelBySlug[slug] || slug;

    return {
        labelBySlug,
        fopMetaBySlug,
        slugs,
        getLabel,
        loading,
        error,
    };
}

export function clearFopLabelsCache() {
    cache = null;
    pending = null;
}
